import { useState } from 'react';
import { FaPlus, FaMinus } from 'react-icons/fa';
import image3 from 'assets/activities/3.jpg'

const AccordionItem = ({ title, content, isOpen, onClick }) => (
  <div className="border-b border-white/10 transition-all duration-300">
    <button
      onClick={onClick}
      className="w-full flex justify-between items-center py-6 text-left text-xl font-bold text-white hover:text-nvcti-orange transition-colors focus:outline-none group"
    >
      <div className="flex items-center gap-4">
        <span className="text-nvcti-orange p-1 rounded-lg bg-nvcti-orange/10 group-hover:bg-nvcti-orange group-hover:text-white transition-all">{isOpen ? <FaMinus /> : <FaPlus />}</span>
        {title}
      </div>
    </button>
    <div
      className={`overflow-hidden transition-all duration-500 ease-in-out ${isOpen ? 'max-h-[300px] opacity-100' : 'max-h-0 opacity-0'
        }`}
    >
      <div className="pl-14 pr-4 pb-6 text-gray-400">
        <p className="text-lg leading-relaxed">{content}</p>
      </div>
    </div>
  </div>
);

const Think = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(index === openIndex ? null : index);
  };

  const accordionData = [
    {
      title: 'Training Programs',
      content:
        'The centre offers a wide range of training programs aimed at enhancing skills and knowledge in specific areas. These programs may cover technical skills, leadership development, project management, entrepreneurship, and other relevant subjects. The training sessions are conducted by experienced professionals or subject matter experts.',
    },
    {
      title: 'State-of-the-art Facilities',
      content:
        'The centre is equipped with cutting-edge facilities and resources to support innovation and training activities. This may include advanced technology tools, prototyping equipment, software and hardware resources, multimedia rooms, and research materials.',
    },
    {
      title: 'Expert Mentors and Coaches',
      content:
        'The centre provides access to expert mentors and coaches who guide and support individuals or teams throughout their innovation and training journeys. These mentors bring extensive industry experience and offer valuable insights and feedback.',
    },
  ];

  return (
    <section id="think-innovation" className="py-24 bg-dark-secondary overflow-hidden scroll-mt-24">
      <div className="container mx-auto px-6">
        <div className="flex flex-col lg:flex-row gap-16 items-center">
          {/* Left Content */}
          <div className="lg:w-1/2">
            <h4 className="text-nvcti-orange font-bold uppercase tracking-widest text-sm mb-3">Empowering Minds</h4>
            <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-8 leading-tight">
              Think, <span className="text-nvcti-orange">Innovate</span> & Create
            </h2>
            <p className="text-gray-300 text-lg mb-10 leading-relaxed">
              The centre serves as a dedicated space for fostering innovation and creativity. It
              provides a collaborative environment where individuals or teams can brainstorm,
              ideate, and develop innovative solutions to address various challenges and problems.
            </p>

            {/* Accordion */}
            <div className="divide-y divide-white/10 border-t border-white/10">
              {accordionData.map((item, index) => (
                <AccordionItem
                  key={index}
                  title={item.title}
                  content={item.content}
                  isOpen={openIndex === index}
                  onClick={() => toggle(index)}
                />
              ))}
            </div>
          </div>

          {/* Right Image */}
          <div className="lg:w-1/2">
            <div className="bg-dark-tertiary p-6 rounded-3xl shadow-2xl relative group">
              <div className="absolute inset-0 bg-accent-primary/20 blur-3xl rounded-full opacity-50 group-hover:opacity-100 transition-opacity"></div>
              <img
                src={image3}
                alt="Innovation"
                className="w-full max-w-xl rounded-2xl object-cover relative z-10 brightness-110 shadow-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Think;
